import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// This validators are used to neglect the empty spaces
export class CustomValidators {

    /**
     * @description To Empty space validator
     * @author njagadeesan
     * @date 2019-12-17
     * @static
     * @param {AbstractControl} control
     * @returns {ValidationErrors}
     * @memberof CustomValidators
     */
    static requiredNotEmpty(control: AbstractControl): ValidationErrors {
        if (!CustomValidators.hasValue(control.value)) {
            return { required: true };
        }
        return null;
    }
    /**
     * @description Minlength not empty validator
     * @author njagadeesan
     * @date 2020-01-07
     * @static
     * @param {number} minLength
     * @returns {ValidatorFn}
     * @memberof CustomValidators
     */
    static minLength(minLength: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!CustomValidators.hasValue(control.value)) {
                return null;  // don't validate empty values to allow optional controls
            }
            const length: number = CustomValidators.isString(control.value) ? control.value.trim().length : 0;
            return length < minLength ? {
                'minlength': {
                    'requiredLength': minLength, 'actualLength': length
                }
            } : null;
        };
    }

    /**
     * @description To check empty spaces by trimming the value
     * @author njagadeesan
     * @date 2019-12-17
     * @static
     * @param {string} value
     * @returns {boolean}
     * @memberof CustomValidators
     */
    static hasValue(value: string): boolean {
        if (CustomValidators.isString(value)) {
            value = value && value.trim();
        }
        return value !== undefined && value !== null && value !== '';
    }
    /**
     * @description To Check String value
     * @author njagadeesan
     * @date 2020-01-07
     * @static
     * @param {*} value
     * @returns {boolean}
     * @memberof CustomValidators
     */
    static isString(value: any): boolean {
        return typeof (value) === 'string';
    }
     /**
     * @description To Allow alpha numberic values 
     * @date 2021-02-18
     * @static
     * @memberof CustomValidators
     */
    public static alphaNumericCharacterValidation(control: AbstractControl): { [key: string]: boolean } {
        if (control.value === undefined || control.value === null) return undefined;
        let value: string = control.value;
        if (value.length === 0) {
            return undefined;
        }
        let alphaNumericPattern = /[^A-Za-z0-9\-\s]+/g;
        if (new RegExp(alphaNumericPattern).test(value)) {
            return { 'alphaNumericValidation': true };
        }
        return undefined;
    };
      /**
     * @description To restict empty spaces between alphanumerics 
     * @date 2021-02-18
     * @static
     * @memberof CustomValidators
     */
    public static cannotContainSpace(control: AbstractControl) :{ [key: string]: boolean } {
        if((control.value as string).indexOf(' ') >= 0){
            return {cannotContainSpace: true}
        }
  
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/Utils/custom-validator.ts